export default "__VITE_ASSET__Bw9S3h5C__"